// @spec GHG-STR-066
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { BestPracticePage } from '@/features/ghg/components/BestPracticePage';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/ghg/best-practices')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.bestPractices'),
  }),
  component: BestPracticesPage,
});

function BestPracticesPage() {
  const { t } = useTranslation('ghg');
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('bestPracticesPage.heading')}</h1>
          <p className="mt-1 text-muted-foreground">
            {t('bestPracticesPage.description')}
          </p>
        </header>

        <BestPracticePage />
      </div>
    </div>
  );
}
